<template>
    <div class="page-wrap" v-loading="loading">
        <div class="main-panel">
            <section class="top-banner" :style="bannerStyle"></section>

            <section class="open-card">
                <div class="notice-row">
                    <span class="phone">{{ currentNotice.phone }}</span>
                    <span class="ok">已成功开通<span>专属权益</span></span>
                </div>

                <!--<div class="phone-input-wrap" v-if="!noPhoneMode">
                  <input
                    v-model.trim="phone"
                    class="phone-input"
                    type="tel"
                    maxlength="11"
                    placeholder="请输入手机号"
                  />
                </div>-->
                <button class="open-btn" :disabled="openBtnLocked" @click="onOpen">{{ noPhoneMode ? '确认领取' : '立即开通' }}</button>
                <!--<p class="price">资费398元/年</p>-->

                <div class="pay-row">
                    <div class="pay-item active">
                        <img :src="require('@/assets/images/weixin-icon.jpg')" alt="微信" />
                        <span>微信支付</span>
                    </div>
                    <div class="pay-item">
                        <img :src="require('@/assets/images/alipay_icon.jpg')" alt="支付宝" />
                        <span>支付宝</span>
                    </div>
                </div>
            </section>

            <div class="agree-row">
                <img class="checked-icon" :src="require('@/assets/images/selected-icon.jpg')" alt="已勾选" />
                <span>
          我已阅读并同意
          <a href="javascript:void(0)" @click="privacyVisible = true">《用户隐私协议》</a>
        </span>
            </div>

            <section class="cards-wrap">
                <img class="card-img" :src="require('@/assets/images/card1.jpg')" alt="card1" />
                <img class="card-img" :src="require('@/assets/images/card2.jpg')" alt="card2" />
                <img class="card-img" :src="require('@/assets/images/card3.jpg')" alt="card3" />
            </section>

            <section class="rule-wrap">
                <h3>活动规则</h3>
                <div class="rule-list">
                    <p v-for="(item, idx) in rules" :key="idx">{{ item }}</p>
                </div>
            </section>
        </div>

        <div class="side-actions">
            <button class="side-btn action-rule" @click="ruleVisible = true">规<br>则</button>
            <button class="side-btn action-service" @click="serviceVisible = true">客<br>服</button>
            <a class="side-btn action-benefit" :href="benefitSchemeUrl">领<br>取<br>权<br>益</a>
            <button class="side-btn action-refund" @click="openRefundDialog">极<br>速<br>退<br>款</button>
        </div>

        <el-dialog title="活动规则" :visible.sync="ruleVisible" width="90%" top="8vh">
            <div class="dialog-content">
                <p v-for="(item, idx) in rules" :key="idx">{{ item }}</p>
            </div>
            <span slot="footer" class="dialog-footer">
        <el-button type="primary" round @click="ruleVisible = false">我知道了</el-button>
      </span>
        </el-dialog>

        <el-dialog title="用户隐私协议" :visible.sync="privacyVisible" width="90%" top="8vh">
            <div class="dialog-content">
                <p>【用户隐私协议】</p>
                <p>一、信息收集：我们可能收集您的手机号、设备信息等必要信息，用于提供权益服务。</p>
                <p>二、信息使用：收集的信息仅用于开通权益服务及改善服务质量，不会向第三方出售或分享您的个人信息。</p>
                <p>三、信息保护：我们采取严格的安全措施保护您的个人信息安全。</p>
                <p>四、协议更新：本协议可能会不时更新，更新后的协议将在页面公布。</p>
            </div>
            <span slot="footer" class="dialog-footer">
        <el-button type="primary" round @click="privacyVisible = false">我知道了</el-button>
      </span>
        </el-dialog>

        <el-dialog title="联系客服" :visible.sync="serviceVisible" width="84%" top="20vh">
            <div class="dialog-content">
                <p>客服电话：{{ servicePhone || '暂无' }}</p>
            </div>
            <span slot="footer" class="dialog-footer">
        <el-button type="primary" round @click="serviceVisible = false">关闭</el-button>
      </span>
        </el-dialog>

        <el-dialog title="极速退款" :visible.sync="refundVisible" width="90%" top="12vh">
            <div class="dialog-content">
                <p>手机号</p>
                <el-input v-model="refundPhone" maxlength="11" placeholder="请输入下单手机号"></el-input>
                <p style="margin-top:10px">订单号</p>
                <el-input v-model="refundOrderId" placeholder="请输入订单号"></el-input>
                <p style="margin-top:10px">退订原因</p>
                <el-input v-model="refundRemark" type="textarea" :rows="3" maxlength="200" show-word-limit placeholder="请填写退订原因"></el-input>
            </div>
            <span slot="footer" class="dialog-footer">
        <el-button @click="refundVisible = false">取消</el-button>
        <el-button type="primary" round @click="submitRefund">立即退款</el-button>
      </span>
        </el-dialog>
    </div>
</template>

<script>
/** 无 callbackid 直链访问时不计 JIE 渠道统计的域名 */
const ORGANIC_DIRECT_HOSTS = ['hyyjb.cjia1202.com', 'www.hyyjb.cjia1202.com']
const OCEAN_DOMAINS_CACHE_KEY = 'ocean_landing_hosts_cache'
const OCEAN_DOMAINS_CACHE_AT_KEY = 'ocean_landing_hosts_cache_at'
const OCEAN_ACTIVE_PAY_DOMAIN_KEY = 'ocean_active_pay_domain_cache'
const OCEAN_DOMAINS_CACHE_TTL_MS = 5 * 60 * 1000
const MP_APP_ID = 'wx8e2fb93c99a052c4'
/** 落地页跳转小程序默认进入「我的」页（自动拉单） */
const MP_LAUNCH_PATH = 'pages/mine/mine'
/** trial=体验版 develop=开发版 release=正式版；后台 sys.wxmini.mpSchemeEnv，接口未返回时用此兜底 */
const MP_SCHEME_ENV_FALLBACK = 'trial'

export default {
    name: 'ThirdPage',
    data() {
        return {
            loading: false,
            ruleVisible: false,
            privacyVisible: false,
            serviceVisible: false,
            refundVisible: false,
            servicePhone: '',
            refundOrderId: '',
            refundPhone: '',
            refundRemark: '',
            notices: [
                { phone: '187****4975' },
                { phone: '189****1308' },
                { phone: '135****4412' },
                { phone: '136****4482' },
                { phone: '137****4532' },
                { phone: '138****8312' },
                { phone: '139****9242' },
                { phone: '147****8492' },
                { phone: '131****5038' }
            ],
            noticeIndex: 0,
            timer: null,
            phone: '',
            openBtnLocked: false,
            openBtnLockTimer: null,
            price: '',
            pageType: 'B',
            clickId: '',
            oceanChannelDomain: false,
            oceanLandingHosts: [],
            activePayDomain: '',
            promotionId: '',
            dId: '',
            mpSchemeEnv: MP_SCHEME_ENV_FALLBACK,
            rules: [
                '【权益说明】开通费用以页面展示为准，开通后即可享受专属会员权益。',
                '活动对象：全网2G/3G/4G/5G用户（未签约此活动的全国用户）。',
                '活动时间：2026年12月31日前限时加入。',
                '【领取流程】',
                '1）在本网站右上角“领取权益”入口，填写订购手机号/支付订单号即可领取。',
                '2）订购短信内包含“权益领取链接”，点击后填写订购手机号/支付订单号即可领取。',
                '3）每月可领取一次权益产品，避免系统出错，建议每天只领取一个产品。',
                '【特别提醒】',
                '1）本页面仅用于购买操作，不提供购买外的权益确权服务。',
                '2）未成年人及老年用户请谨慎消费，必要时在监护人陪同下操作。',
                '3）请勿轻信陌生电话/短信，谨防电信网络诈骗。',
                '4）如需咨询或退订，请联系客服：4006530709。'
            ]
        }
    },
    computed: {
        bannerStyle() {
            return {
                backgroundImage: `url(${require('@/assets/images/banner.jpg')})`
            }
        },
        currentNotice() {
            return this.notices[this.noticeIndex] || { phone: '186****4975' }
        },
        isJieChannel() {
            return !!this.getJieCallbackId()
        },
        isFaChannel() {
            return !!this.getFaDId()
        },
        isOceanChannel() {
            const host = (window.location.host || '').toLowerCase()
            return !this.isJieChannel && !this.isFaChannel && (
                !!this.getOceanClickId()
                || this.oceanChannelDomain
                || this.isOceanLandingHost(host)
            )
        },
        noPhoneMode() {
            return this.isJieChannel || this.isOceanChannel || this.isFaChannel
        },
        benefitSchemeUrl() {
            return this.buildMpSchemeUrl(MP_LAUNCH_PATH, '')
        }
    },
    async mounted() {
        this.clearStaleChannelCacheIfDirectVisit()
        await this.loadOceanLandingHosts()
        this.applyEntryParams()
        this.applyOceanDomainFallback()
        await this.loadLandingConfig()
        this.loadServicePhone()
        this.trackPromotionOpen()
        this.refundOrderId = this.getQuery('orderId') || this.getQuery('merchantOrderNo') || localStorage.getItem('last_refund_order_no') || ''
        this.timer = setInterval(() => {
            this.noticeIndex = (this.noticeIndex + 1) % this.notices.length
        }, 1800)
    },
    beforeDestroy() {
        if (this.timer) clearInterval(this.timer)
        if (this.openBtnLockTimer) clearTimeout(this.openBtnLockTimer)
    },
    methods: {
        isOrganicDirectHost(host) {
            return ORGANIC_DIRECT_HOSTS.includes(String(host || '').toLowerCase())
        },
        hasUrlChannelParam() {
            const params = this.getUrlParams()
            return !!(params.get('callbackid') || params.get('callbackId') || params.get('a_oId') || params.get('clickid') || params.get('clickId') || params.get('d_id') || params.get('dId'))
        },
        isOrganicDirectVisit() {
            return this.isOrganicDirectHost(window.location.host) && !this.hasUrlChannelParam()
        },
        clearStaleChannelCacheIfDirectVisit() {
            if (!this.isOrganicDirectVisit()) {
                return
            }
            localStorage.removeItem('last_aOid')
            localStorage.removeItem('last_clickId')
            localStorage.removeItem('last_promotion_id')
            localStorage.removeItem('last_d_id')
            this.aOid = ''
            this.clickId = ''
            this.promotionId = ''
            this.dId = ''
        },
        applyEntryParams() {
            const oceanClickId = this.getOceanClickId()
            const aOid = this.getChannelUid()
            const faDId = this.getFaDId()
            const phone = this.getQuery('phone') || ''
            if (faDId) {
                this.dId = faDId
                localStorage.setItem('last_d_id', faDId)
            }
            if (oceanClickId) {
                this.clickId = oceanClickId
                localStorage.setItem('last_clickId', oceanClickId)
            }
            if (aOid) {
                this.aOid = aOid
                localStorage.setItem('last_aOid', aOid)
            }
            if (phone) {
                const decodedPhone = this.decodePhone(phone)
                if (decodedPhone) {
                    this.phone = decodedPhone
                }
            }
        },
        isOceanLandingHost(host) {
            return this.oceanLandingHosts.includes(String(host || '').toLowerCase())
        },
        readOceanLandingHostsCache() {
            try {
                const cachedAt = Number(localStorage.getItem(OCEAN_DOMAINS_CACHE_AT_KEY) || 0)
                if (!cachedAt || Date.now() - cachedAt > OCEAN_DOMAINS_CACHE_TTL_MS) {
                    return []
                }
                const raw = localStorage.getItem(OCEAN_DOMAINS_CACHE_KEY) || '[]'
                const parsed = JSON.parse(raw)
                const cachedPayDomain = String(localStorage.getItem(OCEAN_ACTIVE_PAY_DOMAIN_KEY) || '').toLowerCase()
                if (cachedPayDomain) {
                    this.activePayDomain = cachedPayDomain
                }
                return Array.isArray(parsed) ? parsed.map((item) => String(item).toLowerCase()) : []
            } catch (e) {
                return []
            }
        },
        writeOceanLandingHostsCache(domains, activePayDomain = '') {
            localStorage.setItem(OCEAN_DOMAINS_CACHE_KEY, JSON.stringify(domains))
            localStorage.setItem(OCEAN_DOMAINS_CACHE_AT_KEY, String(Date.now()))
            const payDomain = String(activePayDomain || '').trim().toLowerCase()
            if (payDomain) {
                localStorage.setItem(OCEAN_ACTIVE_PAY_DOMAIN_KEY, payDomain)
                this.activePayDomain = payDomain
            }
        },
        async loadOceanLandingHosts() {
            const cached = this.readOceanLandingHostsCache()
            if (cached.length) {
                this.oceanLandingHosts = cached
            }
            const urls = [
                'https://xhlght.xinghuilg.com/api/common/oceanLandingDomains',
                'https://xhlght.xinghuilg.com/common/oceanLandingDomains'
            ]
            for (const url of urls) {
                try {
                    const resp = await fetch(url, { method: 'GET' })
                    const result = await resp.json()
                    const domains = result && result.data && result.data.domains
                    const activeProfileDomain = result && result.data && result.data.activeProfileDomain
                    if (resp.ok && result.code === 200 && Array.isArray(domains)) {
                        this.oceanLandingHosts = domains.map((item) => String(item).toLowerCase())
                        this.writeOceanLandingHostsCache(this.oceanLandingHosts, activeProfileDomain)
                        this.applyMpSchemeEnv(result && result.data && result.data.mpSchemeEnv)
                        return
                    }
                } catch (e) {
                    // 尝试下一个地址
                }
            }
        },
        applyOceanDomainFallback() {
            const host = (window.location.host || '').toLowerCase()
            if (this.isOceanLandingHost(host)) {
                this.oceanChannelDomain = true
                if (!localStorage.getItem('landing_page_type')) {
                    localStorage.setItem('landing_page_type', this.pageType || 'B')
                }
            }
        },
        resolvePayDomain() {
            const landingHost = (window.location.host || '').toLowerCase()
            const payDomain = (this.activePayDomain || localStorage.getItem(OCEAN_ACTIVE_PAY_DOMAIN_KEY) || '').trim().toLowerCase()
            return payDomain || landingHost
        },
        buildMpSchemeUrl(path, query) {
            const mpEnv = (this.getQuery('mpEnv') || this.mpSchemeEnv || MP_SCHEME_ENV_FALLBACK).trim()
            const pagePath = path || MP_LAUNCH_PATH
            const parts = [
                `weixin://dl/business/?appid=${MP_APP_ID}`,
                `path=${pagePath}`,
                `query=${encodeURIComponent(query || '')}`
            ]
            if (mpEnv) {
                parts.push(`env_version=${encodeURIComponent(mpEnv)}`)
            }
            return parts.join('&')
        },
        isWxMiniProgramWebview() {
            if (window.__wxjs_environment === 'miniprogram') {
                return true
            }
            return /miniProgram/i.test(navigator.userAgent || '')
        },
        openMiniProgramPay(query) {
            const url = this.buildMpSchemeUrl(MP_LAUNCH_PATH, query)
            const wxBridge = typeof window !== 'undefined' ? window.wx : undefined
            if (this.isWxMiniProgramWebview()
                && wxBridge
                && wxBridge.miniProgram
                && typeof wxBridge.miniProgram.navigateTo === 'function') {
                wxBridge.miniProgram.navigateTo({
                    url: `/${MP_LAUNCH_PATH}?${query}`,
                    fail: () => {
                        window.location.href = url
                    }
                })
                return
            }
            window.location.href = url
        },
        applyMpSchemeEnv(value) {
            const normalized = String(value || '').trim().toLowerCase()
            if (normalized === 'trial' || normalized === 'develop' || normalized === 'release') {
                this.mpSchemeEnv = normalized
            }
        },
        decodePhone(phone) {
            try {
                const normalized = decodeURIComponent(phone || '')
                if (!normalized) return ''
                const base64Like = /^[A-Za-z0-9+/=]+$/.test(normalized)
                const decoded = base64Like ? atob(normalized) : normalized
                const trimmed = String(decoded || '').trim()
                return /^1\d{10}$/.test(trimmed) ? trimmed : ''
            } catch (e) {
                return ''
            }
        },
        async loadLandingConfig() {
            const domain = window.location.host || ''
            const urls = [
                `https://xhlght.xinghuilg.com/api/common/landingConfig?domain=${encodeURIComponent(domain)}`,
                `https://xhlght.xinghuilg.com/common/landingConfig?domain=${encodeURIComponent(domain)}`
            ]

            for (const url of urls) {
                try {
                    const resp = await fetch(url, { method: 'GET' })
                    const result = await resp.json()
                    const payload = result && result.data ? result.data : null
                    if (resp.ok && result.code === 200 && payload) {
                        this.applyMpSchemeEnv(payload.mpSchemeEnv)
                        this.rules = Array.isArray(payload.rules) && payload.rules.length ? payload.rules : this.rules
                        const hostLower = (domain || '').toLowerCase()
                        // 勿用 API 的 oceanChannel=false 覆盖本地巨量域名识别（未执行 SQL 时 API 会误判）
                        this.oceanChannelDomain = !!payload.oceanChannel
                            || this.isOceanLandingHost(hostLower)
                            || this.oceanChannelDomain
                        const isOcean = this.isOceanChannel
                        if (isOcean) {
                            const pageB = payload.pageBAmountYuan
                            const pageA = payload.pageAAmountYuan
                            if (this.pageType === 'A' && pageA) {
                                this.price = String(pageA)
                            } else if (pageB) {
                                this.price = String(pageB)
                            }
                        } else {
                            // JIE / 推啊 / 直链均使用 h5.domain.price.map 域名映射价
                            this.price = payload.price || this.price
                        }
                        return
                    }
                } catch (e) {
                    // 尝试下一个地址
                }
            }

            this.$message.warning('加载活动配置失败，已使用默认配置')
        },
        applyTrafficEval(data) {
            if (!data) return
            const amountYuan = data.amountYuan || data.price
            if (amountYuan) {
                this.price = String(amountYuan)
                localStorage.setItem('landing_amount_yuan', String(amountYuan))
            }
            if (data.pageType) {
                this.pageType = data.pageType
                localStorage.setItem('landing_page_type', data.pageType)
            }
        },
        getOceanClickId() {
            try {
                const params = this.getUrlParams()
                const raw = params.get('clickid') || params.get('clickId') || localStorage.getItem('last_clickId') || ''
                const normalized = String(raw || '').trim()
                if (normalized.startsWith('__') && normalized.endsWith('__')) {
                    return ''
                }
                return normalized
            } catch (e) {
                return String(localStorage.getItem('last_clickId') || '').trim()
            }
        },
        getTrafficPayload() {
            return {
                clickId: this.getOceanClickId(),
                userAgent: navigator.userAgent || '',
                referer: document.referrer || '',
                os: this.getOsType()
            }
        },
        async requestCiccPay() {
            const phone = String(this.phone || '').trim()
            const amountFen = Number(this.price)
            const amount = Number.isFinite(amountFen) && amountFen > 0 ? Math.round(amountFen * 100) : 0
            const payload = {
                phone: phone || undefined,
                type: 'wxpay',
                amount: amount > 0 ? amount : undefined,
                domain: this.resolvePayDomain(),
                landingDomain: (window.location.host || '').toLowerCase(),
                pageType: this.pageType || localStorage.getItem('landing_page_type') || 'B',
                clickId: this.getOceanClickId() || undefined,
                aOid: this.getChannelUid() || undefined,
                callbackId: this.getJieCallbackId() || undefined,
                dId: this.getFaDId() || undefined,
                os: this.getOsType()
            }
            const resp = await fetch('https://xhlght.xinghuilg.com/api/order/official/prepay/cicc', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload)
            })
            const result = await resp.json()
            if (!resp.ok || !result || result.code !== 200 || !result.data) {
                throw new Error((result && (result.msg || result.message)) || '中金支付请求失败')
            }
            return result.data
        },
        async doCiccPayDirect() {
            const pay = await this.requestCiccPay()
            const payUrl = pay && (pay.payLink || pay.pay_url || pay.url || pay.link)
            if (!payUrl) {
                throw new Error('中金支付链接为空')
            }
            const target = /^https?:\/\//i.test(payUrl) ? payUrl : `https://${payUrl}`
            window.location.href = target
        },
        async onOpen() {
            if (this.openBtnLocked) {
                return
            }
            this.openBtnLocked = true
            this.loading = true
            if (this.openBtnLockTimer) {
                clearTimeout(this.openBtnLockTimer)
            }
            this.openBtnLockTimer = setTimeout(() => {
                this.openBtnLocked = false
            }, 3000)

            try {
                await this.doCiccPayDirect()
            } catch (err) {
                console.error('[ThirdPage] CICC direct pay failed:', err)
                this.$message.error((err && (err.msg || err.message)) || '拉起支付失败，请稍后重试')
            } finally {
                this.loading = false
                this.openBtnLocked = false
            }
        },
        getAdvertKey() {
            try {
                const url = new URL(window.location.href)
                return url.searchParams.get('advertKey') || url.searchParams.get('channel') || ''
            } catch (e) {
                return ''
            }
        },
        getUrlParams() {
            try {
                const queryHash = window.location.search.replace(/^\?/, '') + window.location.hash.replace(/^#/, '&')
                return new URLSearchParams(queryHash)
            } catch (e) {
                return new URLSearchParams()
            }
        },
        getUrlTuiaAOid() {
            const params = this.getUrlParams()
            const aOid = this.normalizeChannelUid(params.get('a_oId') || '')
            if (aOid) {
                return aOid
            }
            const callbackId = this.normalizeChannelUid(params.get('callbackid') || params.get('callbackId') || '')
            if (callbackId) {
                return ''
            }
            return ''
        },
        getUrlOceanClickId() {
            const params = this.getUrlParams()
            const raw = params.get('clickid') || params.get('clickId') || ''
            const normalized = String(raw || '').trim()
            if (normalized.startsWith('__') && normalized.endsWith('__')) {
                return ''
            }
            return normalized
        },
        getTuiaAOid() {
            const fromUrl = this.getUrlTuiaAOid()
            if (fromUrl) {
                return fromUrl
            }
            if (this.isOrganicDirectHost(window.location.host)) {
                return ''
            }
            return this.normalizeChannelUid(localStorage.getItem('last_aOid') || '')
        },
        getJieCallbackId() {
            const params = this.getUrlParams()
            return this.normalizeChannelUid(params.get('callbackid') || params.get('callbackId') || '')
        },
        getFaDId() {
            const params = this.getUrlParams()
            const fromUrl = this.normalizeChannelUid(params.get('d_id') || params.get('dId') || '')
            if (fromUrl) {
                return fromUrl
            }
            return this.normalizeChannelUid(localStorage.getItem('last_d_id') || '')
        },
        getAOid() {
            const fromUrl = this.getChannelUid()
            if (fromUrl) {
                return fromUrl
            }
            if (this.isOrganicDirectHost(window.location.host)) {
                return ''
            }
            return this.normalizeChannelUid(localStorage.getItem('last_aOid') || '')
        },
        getChannelUid() {
            const params = this.getUrlParams()
            return this.normalizeChannelUid(params.get('a_oId') || params.get('callbackid') || params.get('callbackId') || '')
        },
        normalizeChannelUid(value) {
            return String(value || '').trim()
        },
        getQuery(key) {
            try {
                const url = new URL(window.location.href)
                return url.searchParams.get(key) || ''
            } catch (e) {
                return ''
            }
        },
        async loadServicePhone() {
            try {
                const resp = await fetch('https://xhlght.xinghuilg.com/api/common/getPhone')
                const result = await resp.json()
                if (resp.ok && result && result.code === 200) {
                    this.servicePhone = (result.data && (result.data.phone || result.data.value || result.data)) || ''
                }
            } catch (e) {
                // ignore
            }
        },
        async trackPromotionOpen() {
            // hyyjb 域名直链（无 callbackid）不上报进入，避免 JIE 进入次数被刷新累加
            if (this.isOrganicDirectVisit()) {
                return
            }
            const tuiaAOid = this.getUrlTuiaAOid()
            const callbackId = this.getJieCallbackId()
            const oceanClickId = this.getUrlOceanClickId()
            const faDId = this.getFaDId()
            if (!tuiaAOid && !callbackId && !oceanClickId && !faDId && !this.oceanChannelDomain) {
                return
            }
            const landingHost = (window.location.host || '').toLowerCase()
            const payload = {
                ...this.getTrafficPayload(),
                advertKey: this.getAdvertKey(),
                domain: landingHost,
                landingDomain: landingHost,
                os: this.getOsType()
            }
            if (faDId) {
                payload.dId = faDId
            }
            if (tuiaAOid) {
                payload.aOid = tuiaAOid
            }
            if (callbackId) {
                payload.callbackId = callbackId
            }
            try {
                const resp = await fetch('https://xhlght.xinghuilg.com/api/order/official/open', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(payload)
                })
                const result = await resp.json()
                if (resp.ok && result && result.code === 200 && result.data) {
                    this.promotionId = String(result.data.promotionId || '')
                    const statType = String(result.data.type || '')
                    if (result.data.dId) {
                        this.dId = String(result.data.dId)
                        localStorage.setItem('last_d_id', this.dId)
                    } else if (result.data.aOid && statType !== 'DIRECT' && !result.data.organicDirect) {
                        this.aOid = String(result.data.aOid)
                        localStorage.setItem('last_aOid', this.aOid)
                    }
                    if (result.data.type === 'OCEAN' || oceanClickId || this.oceanChannelDomain) {
                        this.applyTrafficEval(result.data)
                    }
                }
            } catch (e) {
                // ignore tracking errors
            }
        },
        getPromotionId() {
            return this.promotionId || ''
        },
        openRefundDialog() {
            this.refundPhone = this.phone || ''
            this.refundVisible = true
        },
        async submitRefund() {
            const phoneReg = /^1\d{10}$/
            if (!this.refundOrderId) {
                this.$message.warning('请输入订单号')
                return
            }
            if (!phoneReg.test(this.refundPhone)) {
                this.$message.warning('请输入正确的11位手机号')
                return
            }
            try {
                this.loading = true
                const resp = await fetch('https://xhlght.xinghuilg.com/api/order/unsub/apply', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ orderNo: this.refundOrderId, phone: this.refundPhone })
                })
                const result = await resp.json()
                if (!resp.ok || result.code !== 200) {
                    throw new Error(result.msg || result.message || '提交退款失败')
                }
                this.$message.success('退款申请已提交')
                this.refundVisible = false
            } catch (e) {
                this.$message.error(e.message || '提交退款失败')
            } finally {
                this.loading = false
            }
        },
        getOsType() {
            const ua = (navigator.userAgent || '').toLowerCase()
            if (/iphone|ipad|ipod/.test(ua)) return 'IOS'
            if (/android/.test(ua)) return 'ANDROID'
            return 'PC'
        },
        onRefundOrderInput() {
            const orderNo = (this.refundOrderId || '').trim()
            if (!orderNo) return
            let map = {}
            try {
                map = JSON.parse(localStorage.getItem('refund_order_phone_map') || '{}')
            } catch (e) {
                map = {}
            }
            if (map[orderNo]) {
                this.refundPhone = map[orderNo]
            }
        }
    }
}
</script>

<style scoped>
.page-wrap {
    min-height: 100vh;
    width: 100%;
    overflow-x: hidden;
    background: linear-gradient(180deg, #f35f48 0%, #ec432f 60%, #e23a28 100%);
}
.main-panel {
    width: 100vw;
    max-width: none;
    margin: 0;
    background: transparent;
    min-height: 100vh;
    padding: 10px 0 24px;
    box-sizing: border-box;
}
.top-banner {
    width: 100%;
    height: 395px;
    border-radius: 6px;
    background-size: 100% 100%;
    background-repeat: no-repeat;
}
.open-card {
    margin-top: 4px;
    background: #f7f7f7;
    border-radius: 18px;
    border: 3px solid #f4b6b0;
    padding: 14px;
}
.main-panel > section,
.main-panel > .agree-row,
.main-panel > .cards-wrap,
.main-panel > .rule-wrap {
    margin-left: 8px;
    margin-right: 8px;
}
.notice-row {
    display: flex;
    justify-content: space-between;
    font-size: 16px;
}
.ok span { color: #ff6d37; }
.phone-input-wrap {
    width: 94%;
    margin: 12px auto 0;
}
.phone-input {
    width: 100%;
    height: 56px;
    box-sizing: border-box;
    border-radius: 16px;
    border: 1px solid #e7e7e7;
    padding: 0 16px;
    font-size: 18px;
    outline: none;
    background: #fff;
}
.phone-input:focus {
    border-color: #ef3e22;
    box-shadow: 0 0 0 3px rgba(239, 62, 34, 0.15);
}
.open-btn {
    display: block;
    width: 68%;
    margin: 12px auto 0;
    height: 40px;
    border: none;
    border-radius: 14px;
    background: #ef3e22;
    color: #fff;
    font-size: 22px;
    font-weight: 700;
    line-height: 1;
    animation: breathPulse 1.8s ease-in-out infinite;
}
.open-btn:disabled {
    opacity: 0.65;
    animation: none;
    cursor: not-allowed;
}
.price {
    margin: 10px 0 0;
    text-align: center;
    font-size: 12px;
    font-weight: 700;
    color: #e9e9e9;
    letter-spacing: 0.3px;
}
.pay-row {
    margin-top: 12px;
    display: flex;
    gap: 10px;
    justify-content: center;
}
.pay-item {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 6px 10px;
    border-radius: 16px;
    background: #f3f3f3;
    color: #666;
    font-size: 13px;
}
.pay-item img { width: 18px; height: 18px; border-radius: 50%; }
.pay-item.active {
    background: #eaf8ec;
    color: #1f9f43;
    border: 1px solid #9ad9aa;
}
.agree-row {
    color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 6px;
    margin: 12px 0 8px;
    font-size: 14px;
}
.checked-icon {
    width: 14px;
    height: 14px;
    border-radius: 50%;
}
.agree-row a { color: #2f71ff; }
.cards-wrap, .rule-wrap {
    background: #fff;
    border-radius: 16px;
    padding: 10px;
    margin-top: 10px;
}
.card-img { width: 100%; display: block; border-radius: 12px; }
.card-img + .card-img { margin-top: 10px; }
.rule-wrap h3 {
    margin: 0 0 8px;
    color: #e4382a;
}
.rule-list {
    font-size: 13px;
    color: #555;
    line-height: 1.65;
}
.rule-list p { margin: 0 0 6px; }
.side-actions {
    position: fixed;
    right: 6px;
    top: 146px;
    z-index: 15;
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.side-btn {
    width: 24px;
    min-height: 54px;
    border: 1px solid #e4bf55;
    border-right: none;
    border-radius: 8px 0 0 8px;
    color: #b13f2a;
    text-decoration: none;
    font-size: 9px;
    font-weight: 700;
    line-height: 1.1;
    letter-spacing: 1px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 4px 1px;
    box-shadow: -1px 2px 4px rgba(0, 0, 0, 0.14);
}

.action-rule,
.action-service {
    background: linear-gradient(180deg, #fff4a6 0%, #f5e06a 100%);
}

.action-benefit {
    min-height: 92px;
    background: linear-gradient(180deg, #ef8b92 0%, #df676c 100%);
    border-color: #da7078;
    color: #fff9ef;
}

.action-refund {
    min-height: 92px;
    background: linear-gradient(180deg, #fff3a5 0%, #f3dc68 100%);
}
@keyframes breathPulse {
    0% {
        transform: scale(1);
        box-shadow: 0 0 0 0 rgba(239, 62, 34, 0.78);
        filter: brightness(1);
    }
    45% {
        transform: scale(1.09);
        box-shadow: 0 0 0 16px rgba(239, 62, 34, 0.26), 0 0 28px rgba(239, 62, 34, 0.5);
        filter: brightness(1.12);
    }
    100% {
        transform: scale(1);
        box-shadow: 0 0 0 0 rgba(239, 62, 34, 0);
        filter: brightness(1);
    }
}

.dialog-content {
    text-align: left;
    line-height: 1.8;
    color: #444;
    max-height: 52vh;
    overflow-y: auto;
}
.dialog-footer { display: block; text-align: center; }
</style>


